import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'shrd-uic-flyout-body',
  templateUrl: './flyout.body.component.html',
  styleUrls: ['./flyout.body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlyoutBodyComponent {
  @Input() hasGrid = true;
  @Input() scrollbarEnabled = true;
  @Input() focusEnabled = true;
  @Input() autoUpdateFocusScope = false;

  @HostBinding('class.shrd-uic-flyout-body') readonly hostClass = true;
}
